import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FaqSection from './FAQKeyword';
import FleetHighway from './FleetHighway';
import ContactShowcase from './phoneToWhatsApp';
import TestimonialSectionKeyword from './TestimonialSectionKeyword';

function Volvobushireinpune() {



const cardData =
{
  keyword: 'Volvo Bus Hire in Pune',
  heading: 'Sanavi Travels: Volvo Bus Hire in Pune',
  headingDescription: 'Sanavi Travels offers premium and highly reliable Volvo Bus Hire in Pune, designed for travelers who prioritize comfort, safety, and a luxury travel experience. Pune is a major hub for corporate travel, tourism, educational tours, weddings, and long-distance outstation journeys, and Volvo buses are the preferred choice for smooth, fatigue-free travel on highways and long routes. Our Volvo bus hire service in Pune is ideal for corporate offsite trips, luxury group tours, destination weddings, family vacations, school and college excursions, pilgrimage tours, and outstation travel to destinations such as Mumbai, Goa, Mahabaleshwar, Shirdi, Pandharpur, and Konkan regions.',

  top: 'Popular Travel Experiences with Volvo Bus Hire in Pune',

  "topPlaces": [
    {
      "title": "Corporate Offsite & Business Tours",
      "description": "Volvo bus hire in Pune is widely used for corporate offsite trips, conferences, seminars, and team-building events. Companies prefer Volvo buses for their superior comfort, quiet cabins, and smooth ride quality, allowing employees and management to travel long distances without fatigue. Group travel in a single luxury Volvo bus ensures punctual arrivals, professional travel management, and a relaxed environment for discussions and networking during the journey."
    },
    {
      "title": "Luxury Outstation Travel from Pune",
      "description": "Pune is well-connected to major tourist and business destinations such as Mumbai, Goa, Nashik, Aurangabad, Kolhapur, and Solapur. Volvo buses are ideal for long-distance outstation travel due to their advanced suspension, comfortable seating, and stable highway performance. Travelers enjoy a premium journey with fewer breaks, less travel stress, and a calm, controlled driving experience."
    },
    {
      "title": "Wedding & Event Guest Transportation",
      "description": "Volvo bus hire is a preferred option for transporting wedding guests and event attendees in Pune. Luxury Volvo buses add elegance and convenience to wedding logistics, ensuring guests travel together comfortably between venues, hotels, and destinations. Coordinated group transport helps avoid delays, parking issues, and confusion during large celebrations."
    },
    {
      "title": "Family & Group Vacations",
      "description": "Large families and group travelers choose Volvo buses for vacations and leisure trips from Pune. Traveling together in a single bus enhances bonding, simplifies coordination, and ensures comfort for all age groups, including children and senior citizens. Spacious seating and smooth rides make long journeys enjoyable and relaxing."
    },
    {
      "title": "School & College Educational Tours",
      "description": "Educational institutions opt for Volvo buses for school picnics, college industrial visits, and educational tours. Volvo buses provide safe seating, controlled driving, and reliable scheduling, ensuring students and faculty travel comfortably and securely on long routes."
    },
    {
      "title": "Religious & Pilgrimage Tours",
      "description": "Volvo buses are increasingly used for pilgrimage tours from Pune to destinations like Shirdi, Pandharpur, Bhimashankar, and Ashtavinayak temples. Devotees prefer Volvo travel for its smooth ride, reduced fatigue, and peaceful journey, especially during overnight or long-distance trips."
    },
    {
      "title": "Picnic & Leisure Trips",
      "description": "For group picnics and leisure outings around Pune, Volvo buses offer a premium travel experience. Groups can relax, enjoy scenic routes, and reach picnic destinations comfortably without worrying about traffic, navigation, or parking."
    },
    {
      "title": "VIP & Luxury Group Travel",
      "description": "Volvo buses are ideal for VIP transport, celebrity movement, and high-profile group travel. The luxury interiors, quiet cabins, and professional service create a premium impression and ensure dignified, comfortable travel."
    },
    {
      "title": "Night Travel & Long Routes",
      "description": "Volvo buses are well-suited for night travel and long overnight routes from Pune. Advanced safety systems, stable handling, and experienced drivers ensure safe and restful journeys even during late-night or early-morning travel."
    },
    {
      "title": "Stress-Free Group Coordination",
      "description": "Traveling in a single Volvo bus eliminates the need for multiple vehicles, reduces coordination challenges, and ensures the entire group arrives together. This makes Volvo bus hire a preferred solution for organized, hassle-free group travel."
    }
  ],

  "services": [
    {
      "name": "Volvo Bus Hire in Pune",
      "description": "Sanavi Travels provides premium Volvo bus hire services in Pune for corporate travel, luxury tours, family vacations, weddings, and long-distance outstation journeys. Our Volvo buses are designed for maximum comfort, featuring spacious pushback seating, excellent legroom, climate-controlled interiors, and smooth suspension systems. With experienced drivers and well-maintained vehicles, we ensure a safe, relaxed, and luxurious group travel experience for every journey."
    },
    {
      "name": "AC Volvo Bus Hire Pune",
      "description": "AC Volvo buses offer superior cooling, quiet cabins, and a comfortable environment, making them ideal for summer travel, long-distance journeys, and premium group tours. Passengers can enjoy a fatigue-free ride with consistent temperature control and smooth handling."
    },
    {
      "name": "Luxury Volvo Bus Rental Pune",
      "description": "Luxury Volvo bus rentals are perfect for high-end travel requirements such as corporate events, destination weddings, VIP movement, and premium tourist groups. These buses provide a refined travel experience with modern interiors and superior ride quality."
    },
    {
      "name": "32 Seater Volvo Bus Pune",
      "description": "32 seater Volvo buses are ideal for medium-sized groups seeking comfort and luxury. They balance seating capacity with ample space, making them suitable for corporate tours, family trips, and educational excursions."
    },
    {
      "name": "35 Seater Volvo Bus Hire Pune",
      "description": "35 seater Volvo buses cater to larger groups while maintaining comfort and safety standards. These buses are commonly used for school trips, corporate outings, weddings, and long-distance group travel from Pune."
    },
    {
      "name": "Volvo Bus for Corporate Pune",
      "description": "Corporate Volvo bus services support professional travel for meetings, conferences, offsite events, and employee outings. Reliable scheduling, comfortable seating, and professional drivers ensure efficient and stress-free corporate transportation."
    },
    {
      "name": "Volvo Bus for Family Pune",
      "description": "Family travel in Volvo buses ensures safety, comfort, and convenience for all age groups. Spacious seating and smooth rides make long journeys enjoyable for families traveling together."
    },
    {
      "name": "Volvo Bus for Wedding Pune",
      "description": "Wedding guest transportation using Volvo buses adds luxury and organization to wedding logistics. Guests can travel comfortably and arrive on time, enhancing the overall wedding experience."
    },
    {
      "name": "Volvo Bus for Picnic Pune",
      "description": "For group picnics and leisure outings, Volvo buses offer a premium way to travel together, relax during the journey, and enjoy the trip without driving stress."
    },
    {
      "name": "Volvo Bus for Outstation Pune",
      "description": "Outstation Volvo bus services from Pune provide reliable, comfortable, and safe long-distance travel with planned breaks, experienced drivers, and superior vehicle performance on highways."
    }
  ],

  "tableData": [
    ["Volvo Bus Hire Pune", "AC Volvo Bus"],
    ["Luxury Volvo Bus", "32 Seater Volvo Bus"],
    ["35 Seater Volvo Bus", "Corporate Travel"],
    ["Wedding Transport", "Family Tours"],
    ["Picnic Trips", "Outstation Travel"]
  ],

  "whychoose": [
    {
      "WhyChooseheading": "Premium Comfort & Luxury",
      "WhyChoosedescription": "Volvo buses provide unmatched comfort with smooth suspension, spacious seating, and quiet interiors for long journeys."
    },
    {
      "WhyChooseheading": "Experienced Professional Drivers",
      "WhyChoosedescription": "Our drivers are trained for highway and long-distance travel, ensuring safe, punctual, and smooth journeys."
    },
    {
      "WhyChooseheading": "Well-Maintained Fleet",
      "WhyChoosedescription": "All Volvo buses are regularly serviced, cleaned, and safety-checked before every trip."
    },
    {
      "WhyChooseheading": "Ideal for Long-Distance Travel",
      "WhyChoosedescription": "Volvo buses are designed for highways and overnight routes, reducing travel fatigue."
    },
    {
      "WhyChooseheading": "Flexible Rental Packages",
      "WhyChoosedescription": "We offer customizable rental plans based on distance, duration, and travel requirements."
    },
    {
      "WhyChooseheading": "Transparent Pricing",
      "WhyChoosedescription": "Clear and upfront pricing with no hidden charges."
    },
    {
      "WhyChooseheading": "Group-Friendly Travel",
      "WhyChoosedescription": "Entire groups can travel together comfortably in a single luxury bus."
    },
    {
      "WhyChooseheading": "Trusted Travel Partner",
      "WhyChoosedescription": "Sanavi Travels is known for reliable and professional Volvo bus hire services in Pune."
    }
  ]
};

const faqData = [
  { question: 'Do you provide Volvo bus hire in Pune?', answer: 'Yes, Sanavi Travels offers reliable Volvo bus hire services in Pune for various travel needs.' },
  { question: 'Are AC Volvo buses available for hire?', answer: 'Yes, all our Volvo buses are fully air-conditioned and designed for premium comfort.' },
  { question: 'What seating capacities are available in Volvo buses?', answer: 'We provide 32 seater and 35 seater Volvo buses depending on group size.' },
  { question: 'Is Volvo bus hire suitable for outstation travel?', answer: 'Yes, Volvo buses are ideal for long-distance and outstation travel from Pune.' },
  { question: 'Do you provide Volvo buses for corporate travel?', answer: 'Yes, Volvo buses are widely used for corporate tours, offsite meetings, and conferences.' },
  { question: 'Can Volvo buses be hired for weddings?', answer: 'Yes, Volvo buses are commonly used for wedding guest transportation and destination weddings.' },
  { question: 'Are drivers included with Volvo bus hire?', answer: 'Yes, all Volvo bus rentals include experienced professional drivers.' },
  { question: 'Is advance booking required?', answer: 'Advance booking is recommended, especially during peak seasons and weekends.' },
  { question: 'Are Volvo buses safe for night travel?', answer: 'Yes, Volvo buses are designed for safe night and highway travel with trained drivers.' },
  { question: 'Can the itinerary be customized?', answer: 'Yes, travel routes and schedules can be customized as per your requirements.' }
];

const testimonials = [
  {
    id: 1,
    name: 'Mr. Rahul Deshmukh',
    feedback: 'We hired a Volvo bus from Sanavi Travels for our corporate offsite. Excellent comfort and professional service.',
    rating: 5
  },
  {
    id: 2,
    name: 'Ms. Neha Kulkarni',
    feedback: 'Our family trip from Pune in a Volvo bus was extremely comfortable. Smooth ride and great driver.',
    rating: 5
  }
];













































  const Images = [
    { place: "/images/keyword/1.jpg", text: "Tempo Traveller On Rent in Pune", link: "tempo-traveller-on-rent-in-pune" },
    { place: "/images/keyword/2.jpg", text: "Pune to Shirdi Tempo Traveller On Rent", link: "pune-to-shirdi-tempo-traveller-on-rent" },
    { place: "/images/keyword/3.jpg", text: "Pune to Mahabaleshwar Tempo Traveller on Rent", link: "pune-to-mahabaleshwar-tempo-traveller-on-rent" },
    { place: "/images/keyword/4.jpg", text: "Pune to Goa Tempo Traveller Hire", link: "pune-to-goa-tempo-traveller-hire" },
    { place: "/images/keyword/5.jpg", text: "Pune to Mumbai Tempo Traveller on Rent", link: "pune-to-mumbai-tempo-traveller-on-rent" },
    { place: "/images/keyword/6.jpg", text: "Pune to Konkan Darshan Tempo Traveller Hire", link: "pune-to-konkan-darshan-tempo-traveller-hire" },
    { place: "/images/keyword/7.jpg", text: "Pune to Nashik Tempo Traveller On Rent", link: "pune-to-nashik-tempo-traveller-on-rent" },
    { place: "/images/keyword/8.jpg", text: "Tempo Traveller On Rent for Pune Darshan", link: "tempo-traveller-on-rent-for-pune-darshan" },
    { place: "/images/keyword/9.jpg", text: "Mini Bus On Rent in Pune", link: "mini-bus-on-rent-in-pune" },
    { place: "/images/keyword/10.jpg", text: "13 Seater Tempo Traveller On Rent in Pune", link: "13-seater-tempo-traveller-on-rent-in-pune" },
    { place: "/images/keyword/11.jpg", text: "17 Seater Tempo Traveller on Rent in Pune", link: "17-seater-tempo-traveller-on-rent-in-pune" },
    { place: "/images/keyword/12.jpg", text: "20 Seater Luxury Bus On Rent Pune", link: "20-seater-luxury-bus-on-rent-pune" },
    { place: "/images/keyword/13.jpg", text: "26 Seater Tempo Traveller On Rent in Pune", link: "26-seater-tempo-traveller-on-rent-in-pune" },
    { place: "/images/keyword/14.jpg", text: "32 Seater Luxury Bus On Rent in Pune", link: "32-seater-luxury-bus-on-rent-in-pune" },
    { place: "/images/keyword/15.jpg", text: "35 Seater Bus on Rent in Pune", link: "35-seater-bus-on-rent-in-pune" },
    { place: "/images/keyword/16.jpg", text: "45 Seater Bus On Rent in Pune", link: "45-seater-bus-on-rent-in-pune" },
    { place: "/images/keyword/17.jpg", text: "50 Seater Bus On Rent in Pune", link: "50-seater-bus-on-rent-in-pune" },
    { place: "/images/keyword/18.jpg", text: "Bus Hire for School Trips in Pune", link: "bus-hire-for-school-trips-in-pune" },
    { place: "/images/keyword/19.jpg", text: "Bus booking for Wedding in Pune", link: "bus-booking-for-wedding-in-pune" },
    { place: "/images/keyword/20.jpg", text: "Bus Booking for Marriage in Pune", link: "bus-booking-for-marriage-in-pune" },
    { place: "/images/keyword/21.jpg", text: "Bus Service for Corporate in Pune", link: "bus-service-for-corporate-in-pune" },
    { place: "/images/keyword/22.jpg", text: "Bus on Rent For Event in Pune", link: "bus-on-rent-for-event-in-pune" },
    { place: "/images/keyword/23.jpg", text: "Bus Hire for Outstation in Pune", link: "bus-hire-for-outstation-in-pune" },
    { place: "/images/keyword/24.jpg", text: "AC Bus On Rent in Pune", link: "ac-bus-on-rent-in-pune" },
    { place: "/images/keyword/25.jpg", text: "Pune Bus Hire Rental Service", link: "pune-bus-hire-rental-service" },
  ];







const jsonData = {
  "@context": "https://schema.org",
  "@type": "Product",
  "name": "Volvo Bus Hire in Pune - Sanavi Travels",
  "description": "Sanavi Travels offers Volvo buses for hire in Pune for family trips, corporate travel, group tours, weddings, picnics, and outstation trips. AC and Non-AC Volvo buses, 32-seater and 35-seater options are available with professional drivers at affordable rates.",
  "aggregateRating": {
    "@type": "AggregateRating",
    "bestRating": "5",
    "worstRating": "1",
    "ratingValue": "4.7",
    "ratingCount": "10000+"
  }
};









  return (
    <div>


<Helmet>
  <title>
    Call : +91 7387507373 | Volvo Bus Hire in Pune | Sanavi Travels
  </title>

  <meta
    name="description"
    content="Book Volvo buses for hire in Pune with Sanavi Travels. AC & Non-AC 32-seater and 35-seater Volvo buses for family trips, corporate travel, group tours, weddings, picnics, and outstation trips with driver at best prices."
  />

  <script type="application/ld+json">
    {JSON.stringify(jsonData)}
  </script>
</Helmet>

      <div className="page-headder bg-section parallaxie">
        <div className="container">
          <div className="row">
            <div className="col-lg-12">
              <div className="page-header-box text-white">
                <h1 className="text-anime-style-3 text-center text-white" data-cursor="-opaque">
                  <h3> {cardData.keyword}</h3>
                </h1>
              </div>
            </div>
          </div>
        </div>
      </div>





      <section>
        <div className="container-fluid" >
          <div className="row container-fluid p-0">
            <div className="col-12 col-md-7 bg-foootr">
              <img src='/images/keyword/278.jpg' alt='img' className='img-fluid' />
              <h3 className="py-1"
                style={{
                  color: '#183765', // Red color for the title 
                  textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                  fontWeight: 'bold'
                }}


              >{cardData.heading} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
              <div className="topPlaces">
                <p className="sectionLead">{cardData.top}</p>

                {cardData.topPlaces.map((place, index) => (
                  <article key={index} className="placeCard" tabIndex="0">
                    <span className="placeBadge">{String(index + 1).padStart(2, "0")}</span>

                    <div className="placeBody">
                      <h4 className="placeTitle">{place.title}</h4>
                      <p className="placeDesc">{place.description}</p>
                    </div>

                    <span className="placeArrow" aria-hidden>›</span>
                  </article>
                ))}
              </div>



              <div className="shambhu-services">
                {cardData.services.map((service, index) => (
                  <div key={index} className="sh-service-card">

                    <div className="sh-service-left">
                      <div className="sh-service-icon">
                        🚖
                      </div>
                    </div>

                    <div className="sh-service-content">
                      <h4 className="sh-service-title">{service.name}</h4>
                      <p className="sh-service-desc">{service.description}</p>
                    </div>

                  </div>
                ))}
              </div>


              <table className="table table-responsive Border-key my-2">
                <tbody className=' Border-key'>
                  {cardData.tableData.map((row, rowIndex) => (
                    <tr className='Border-key ' key={rowIndex}>
                      {row.map((cell, cellIndex) => (
                        <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                      ))}
                    </tr>
                  ))}
                </tbody>
              </table>
              <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
              <BusRatesTable />

              <div id="why-choose-section" className="why-choose-section">


                {/* Section Title */}
                <h2 className="section-title">
                  Why Choose <span>Sanavi Travels </span>
                </h2>

                {/* Cards */}
                <div className="cards-grid">
                  {cardData.whychoose.map((item, index) => (
                    <div key={index} className="why-card">
                      <div className="icon-circle">{index + 1}</div>
                      <h4 className="card-heading">{item.WhyChooseheading}</h4>
                      <p className="card-desc">{item.WhyChoosedescription}</p>
                    </div>
                  ))}
                </div>
              </div>



              <div className="row twm-faq-section-1 m-b30">


                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                  <div className="twm-faq-info-wrap">

                    <div className="section-head left">
                      <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Sanavi Travels </h2>
                    </div>


                    <div className="twm-faq-info">
                      <div className="accordion twm-acdn" id="sf-faq-accordion">

                        <FaqSection
                          title="Frequently Asked"
                          subtitle="Help & Info"
                          items={faqData}
                        />

                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <TestimonialSectionKeyword
                testimonials={testimonials}
              />


              <ContactShowcase />
            </div>

            <div className='col-12 col-md-4' >
              <div className="routeList">
                {Images.map((e, i) => {
                  const isExternal = typeof e.link === "string" && /^https?:\/\//i.test(e.link);
                  const href = isExternal ? e.link : `/${String(e.link || "").replace(/^\/+/, "")}`;

                  return (
                    <a
                      key={e.link || i}
                      href={href}
                      className="routeItem"
                      aria-label={e.text}
                      {...(isExternal ? { target: "_blank", rel: "noopener noreferrer" } : {})}
                    >
                      <div className="routeThumb">
                        <img src={e.place} alt="" loading="lazy" />
                      </div>

                      <div className="routeMeta">
                        <h6 className="routeTitle">{e.text}</h6>
                        <span className="routeUnderline" />
                      </div>

                      <span className="routeArrow" aria-hidden>›</span>
                    </a>
                  );
                })}
              </div>




              <div>
                <FleetHighway />
              </div>
              <div className="pc-contact">
                <h4 className="pc-title">Contact Information</h4>

                <div className="pc-grid">
                  {/* Phones */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-telephone-fill"></i>
                      <span>Phone Numbers</span>
                    </header>

                    <div className="pc-list">
                      <a href="tel:+917387507373" className="pc-call">+91 7387507373</a>
                      <a href="tel:+919595532929" className="pc-call">+91 9595532929</a>
                    </div>

                    <div className="pc-cta">
                      <a
                        href="https://wa.me/917387507373"
                        target="_blank" rel="noopener noreferrer"
                        className="pc-whats"
                      >
                        <i className="bi bi-whatsapp me-1"></i> WhatsApp
                      </a>
                      <a href="tel:+917387507373" className="pc-primary">
                        Call Now
                      </a>
                    </div>
                  </section>

                  {/* Email */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-envelope-fill"></i>
                      <span>Email</span>
                    </header>

                    <a href="mailto:booking@sanavitravels.com" className="pc-email">
                      booking@sanavitravels.com
                    </a>
                  </section>

                  {/* Address */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-house-fill"></i>
                      <span>Address</span>
                    </header>

                    <address className="pc-address">
                      <strong>Sanavi Travels</strong><br />
                      OFFICE NO.6, GROUND FLOOR GAT NO.1110,
                      SHREE GOPINATH MAHARAJ VYAPARI SHED SHIVAJI CHOWK, VARVAND TAL DAUND,
                      DIST PUNE – 412215
                    </address>
                  </section>
                </div>
              </div>


            </div>
          </div>
        </div>
      </section>


    </div>
  );
}

export default Volvobushireinpune;